package dev.danko.roblox_craft_ai.shared.model

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
data class ErrorResponse(
    val error_code: String,
    val message: String,
    val correlation_id: String,
    val details: JsonElement? = null,
    val httpStatus: Int? = null,
    val usedProviderId: String? = null
)
